import React from 'react';
import StoreOverview from "./components/StoreOverview";
import StoreInformation from "./components/StoreInformation";

const Index = ({ skeleton, result }) => {
    return (
        <div className="store-info-wrapper">
            <StoreOverview skeleton={skeleton}
                           result={result}
            />
            <StoreInformation skeleton={skeleton}
                              result={result}
            />
        </div>
    );
};

export default Index;